module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "id_Toc180483607",
      "lang": "en"
    }
  }, [_vm._v("3"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Rejection")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I just got my letter. I didn’t want to say the dirty word.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Rejection")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("! Ouf! Now that felt better.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The letter said that the director was away, too busy, and the show had all been sewn up with the official and verified artefacts and were not disposed to any new hypotheses in an exhibition of this scale and ambition. Not in any shape, form or persuasive evidence. Nada. No mention of our meeting or my ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("cabosh")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" or proposition about Vikings having come around this neck of the woods. No, nothing. There was nothing I could do.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("What was it about me that this happened again and again? Was I born under a curse? I just didn’t seem to have it, whatever")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" it")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" was.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("They were not my real parents, not my real mother and father. Was that it? That’s what it came down to. Something must have happened right at the beginning. So, what was I? I only found out by accident when I noticed there were no photos of me as a baby, only the others. They wouldn’t tell me more. And, while I was thankful to them eternally for all they’d done to raise me from nothing, now they had gone their ways. But still, I didn’t want to be their shame. I would like to show them that they were wrong to doubt me.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I was really discouraged. I was fed up with everything. I was fed up with the way everything had to be rubber-stamped and given the “OK” in a hundred different ways. Of course, in their world of archaeologists and digs and specialists to read scripts and to preserve delicate feelings, and to reconstruct something from nothing, I should be just a helper, a technical aid, someone to hold the microscope steady.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I just had too many ideas, and that was the only thing that excited me.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Now I had to write him, or her, a letter.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I was, in spite of this rejection, an honorable person, and I dealt with things as they came. It was hard. But there it was. They were just doing their job. So, I wrote a business-style letter. Again, as I said before, I thought modesty was my best card to play, even though I wondered about that sometimes. Maybe I needed to be going the other way, shouting from every rooftop how sensational my ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("cabosh")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" was, and how it would change the direction of Canadian archaeology for the next ten years. And it could. So here it was, my first version:")])]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Dear sir, madam,")]), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I just received your missive concerning my proposition. I can sincerely say it was not with joy I received it but understand you must do what you must do and that it is surely a job well done.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("However, it is with modesty that I answer, like Socrates, who, without recommendations or introductions, or any papers or recent conferences, laid before his audience his pertinent questions of belief and prejudice.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Schliemann, also, I believe, trusted not in the traditional beliefs of archaeology research of his time but an aleatory approach in unaccustomed avenues and discovered nonetheless the seven levels of Troy. I feel saddened that the opportunity I offer to be the first to lay before the public even at the first level, and the proof of my cabosh that the Vikings did surely penetrate deeper into the St Lawrence basin of rivers and other outflows and inflows than has been thought, and that the wild grapes of Vinland, as recounted in the Icelandic annals, that have been discovered growing in this region, are in all probability of the same species as the wild grapes that continue to grow here today.")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "block_10",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Michael Dowd")]), _vm._v(" "), _c('p', {
    staticClass: "block_10",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Archaeologist in extremis.")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I was ready for a break. I was going to renew my passport and go away, far, far away, to somewhere where no one knew me, and I was no one, and I could just be myself.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("No one.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("And nothing. That was what I wanted to be.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("A feather flying away, a grain of dust, a dampness in the air. Something that was everywhere and nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("But first, I would find out who this person, Michael Dowd, really was. My not-real mother told me who I was, but now, I could not believe her.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I was, so it seemed, not quite who I thought I was.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4",
    attrs: {
      "id": "calibre_pb_6",
      "lang": "en"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b564f46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 81
// module chunks = 0